import { render, staticRenderFns } from "./RelatorioBoleado.vue?vue&type=template&id=46f957a3&scoped=true&"
import script from "./RelatorioBoleado.vue?vue&type=script&lang=js&"
export * from "./RelatorioBoleado.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioBoleado.vue?vue&type=style&index=0&id=46f957a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f957a3",
  null
  
)

export default component.exports